import { mapValues } from 'lodash';
/**
 * Version 23 migrations: Add roommate setup settings
 */
export default function v28(website) {
  return {
    ...website,
    eventVersion: 28,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'HotelRequest' && layoutItem.config.style.tableTitle &&
        layoutItem.config.style.tableContent) {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            style: {
              ...layoutItem.config.style,
              tableTitle: {
                ...layoutItem.config.style.tableTitle,
                customSettings: {
                  ...layoutItem.config.style.tableTitle.customSettings,
                  spacing: {
                    padding: {
                      paddingBottom: 6,
                      paddingTop: 6,
                      paddingLeft: 16,
                      paddingRight: 16
                    }
                  }
                }
              },
              tableContent: {
                ...layoutItem.config.style.tableContent,
                customSettings: {
                  ...layoutItem.config.style.tableContent.customSettings,
                  spacing: {
                    padding: {
                      paddingBottom: 16,
                      paddingTop: 25,
                      paddingLeft: 16,
                      paddingRight: 16
                    }
                  }
                }
              }
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
